'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasr';
var iconName = 'motorcycle';
var width = 640;
var height = 512;
var aliases = [127949];
var unicode = 'f21c';
var svgPathData = 'M256 16l111.4 0c2.3 4.9 10.6 23 24.9 54 20.8-14.2 31.6-21.5 32.3-22l103.4 0 0 128-86.8 0 23.9 51.8c9.9-2.5 20.2-3.8 30.9-3.8 70.7 0 128 57.3 128 128s-57.3 128-128 128-128-57.3-128-128c0-42.9 21.1-80.9 53.5-104.1l-13-28.2c-39 27.5-64.5 73-64.5 124.3l0 32-74.2 0c-11.2 59.2-63.3 104-125.8 104-70.7 0-128-57.3-128-128S73.3 224 144 224c62.5 0 114.5 44.8 125.8 104l25.4 0c-8-76.4-72.6-136-151.2-136l-80 0 0-48 80 0c36.6 0 70.8 9.8 100.3 26.9l107.8-73.5-15.4-33.4-80.6 0 0-48zm64 232.9c16.2-29.8 39.7-55.1 68.1-73.4l-15.7-33.9-88 60c14 13.9 26.1 29.8 35.5 47.3zM419 128l61 0 0-32-40.6 0-26.7 18.2 6.4 13.8zm55.2 234.1l-32-69.3c-16.1 14.6-26.2 35.8-26.2 59.2 0 44.2 35.8 80 80 80s80-35.8 80-80-35.8-80-80-80c-3.5 0-6.9 .2-10.2 .6 25 54.1 39 84.5 42 91.1l-43.6 20.1-10.1-21.8zM220.3 376l-100.3 0 0-48 100.3 0c-10.2-32.5-40.5-56-76.3-56-44.2 0-80 35.8-80 80s35.8 80 80 80c35.8 0 66.1-23.5 76.3-56z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faMotorcycle = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;